import type { ReactNode } from 'react';

interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export function Sheet({ open, onClose, title, children }: SheetProps) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/50"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg rounded-t-2xl border-t p-6"
        style={{
          backgroundColor: 'var(--ac-surface)',
          borderColor: 'var(--ac-border)',
          color: 'var(--ac-text)',
        }}
      >
        {title ? <h2 className="text-lg font-semibold mb-4">{title}</h2> : null}
        {children}
      </div>
    </div>
  );
}
